<template>
  <div :class="classe + ' ' + (outlined ? 'v-sheet v-sheet--outlined theme--light rounded' : '')">
    <label class="v-label theme--light">{{ label }}</label>
    <div>
      <label class="v-label theme--light DHMSlabel">{{ $t('days') }}</label>
      <v-text-field class="DHMSfield" :dense="dense" v-model="days" hide-details="auto" :disabled="disabled"
        :rules="required ? requiredVal : null" @keyup="emitInput()">
      </v-text-field>
      <label class="v-label theme--light DHMSlabel">{{ $t('hours')
      }}</label>
      <v-text-field class="DHMSfield" :dense="dense" v-model="hours" hide-details="auto" :disabled="disabled"
        :rules="required ? requiredVal : null" @keyup="emitInput()">
      </v-text-field>
      <label class="v-label theme--light DHMSlabel">{{ $t('minutes')
      }}</label>
      <v-text-field class="DHMSfield" :dense="dense" v-model="minutes" hide-details="auto" :disabled="disabled"
        :rules="required ? requiredVal : null" @keyup="emitInput()">
      </v-text-field>
      <label class="v-label theme--light DHMSlabel">{{ $t('seconds')
      }}</label>
      <v-text-field class="DHMSfield" :dense="dense" v-model="seconds" hide-details="auto" :disabled="disabled"
        :rules="required ? requiredVal : null" @keyup="emitInput()">
      </v-text-field>
    </div>
  </div>
</template>

<script>

export default {
  name: "DHMS-picker",
  props: {
    label: null,
    value: null,
    outlined: null,
    required: false,
    disabled: false,
    dense: false,
    classe: null,
  },
  data: () => ({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    requiredVal: [(value) => !!value || "Required."],
  }),
  methods: {
    emitInput() {
      let totSeconds = (this.seconds * 1) + (this.minutes * 60) + (this.hours * 60 * 60) + (this.days * 24 * 60 * 60)
      this.$emit("input", totSeconds);
    },
  },
  mounted() {
    if (this.value && this.value > 0) {
      let varSeconds = Number(this.value);
      this.days = Math.floor(varSeconds / 86400);
      this.hours = Math.floor(varSeconds / 3600) - (this.days * 24);
      this.minutes = Math.floor(varSeconds / 60) - (this.days * 24 * 60) - (this.hours * 60);
      this.seconds = varSeconds - (this.days * 24 * 60 * 60) - (this.hours * 60 * 60) - (this.minutes * 60);
    } else {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal && newVal > 0) {
        let varSeconds = Number(newVal);
        this.days = Math.floor(varSeconds / 86400);
        this.hours = Math.floor(varSeconds / 3600) - (this.days * 24);
        this.minutes = Math.floor(varSeconds / 60) - (this.days * 24 * 60) - (this.hours * 60);
        this.seconds = varSeconds - (this.days * 24 * 60 * 60) - (this.hours * 60 * 60) - (this.minutes * 60);
      } else {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
      }
    },
  },
};
</script>
<style>
.DHMSfield {
  width: 25px;
  float: left;
  margin: 0px 10px;
  padding: 0px;
}

.DHMSfield input {
  padding: 0px;
}

.DHMSlabel {
  float: left;
  margin-top: 6px;
  padding: 0px;
}
</style>
